 
class SnailyError extends Error {

    #metadata;

    constructor(message, metadata) {
        super(message);
        this.name = "SnailyError";
        this.#metadata = metadata;

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SnailyError);
        }
    }

    get metadata() {
        return this.#metadata;
    }

    toString() {
        let result = `${super.toString()}; Metadata: ${JSON.stringify(this.#metadata)}`;
        return result;
    }

}

class ExtensionNotInstalledError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ExtensionNotInstalledError";

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ExtensionNotInstalledError);
        }
    }

    get skipLogging() {
        return true;
    }
}

const officialEmojiExpression = () => {
    // https://mths.be/emoji
    return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC08\uDC26](?:\u200D\u2B1B)?|[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
};

const utils = (function () {

    function isJson(obj) {
        let result = obj && obj.constructor === {}.constructor;
        return result;
    }

    function cutFirstLine(source) {
        let result = source.substring(source.indexOf('\n') + 2);
        return result;
    }

    let monthAbbr = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];

    function unifyHoursOrMinutes(source) {
        if (source < 10) {
            return `0${source}`;
        }

        return source;
    }

    function unofficialEmojiExpression() {
        return /\u2388/g;
    }

    return {

        toString (obj) {
            let result = "";
            if (obj instanceof Error) {
                do {
                    result += obj.stack;
                    if (obj.InnerError) {
                        obj = obj.InnerError;
                        result += "\n *** Inner error ***\n";
                    } else {
                        obj = null;
                    }
                } while (obj)
            } else if (isJson(obj)) {
                result = JSON.stringify(obj);
            } else {
                result = obj;
            }
            return result;
        },

        timeConverter (timestamp) {
            let unixTimeStamp = parseInt(timestamp);
            const result = new Date(unixTimeStamp).toLocaleString();
            return result;
        },

        isJson,

        cutFirstLine,

        getStackTrace () {
            let error = new Error();
            let withoutErrorLine = cutFirstLine(error.stack);
            let result = cutFirstLine(withoutErrorLine);
            return result;
        },

        isIterable (obj) {
            if (!obj) {
                return false;
            }

            const result = typeof obj[Symbol.iterator] === 'function';
            return result;
        },

        addDays (date, days) {
            let hours = 24;
            let minutes = 60;
            let seconds = 60;
            let dateEpoch = date.getTime() + days * hours * minutes * seconds * 1000;
            let result = new Date(dateEpoch);
            return result;
        },

        addMinutes (date, minutes) {
            let seconds = 60;
            let dateEpoch = date.getTime() + minutes * seconds * 1000;
            let result = new Date(dateEpoch);
            return result;
        },

        dateTimeToString(source) {
            let result = `${source.getDate()} ${monthAbbr[source.getMonth()]} ${source.getFullYear()} ${unifyHoursOrMinutes(source.getHours())}:${unifyHoursOrMinutes(source.getMinutes())}`;
            return result;
        },

        toDateFromIso8651(source) {
            let number = Date.parse(source);
            if (isNaN(number)) {
                return null;
            }

            let result = new Date(number);
            return result;
        },

        toDateFromEpoch(epoch) {
            //let utcEpoch = epoch + 60 * 1000 * (new Date().getTimezoneOffset());
            //let result = new Date(utcEpoch);
            //return result;
            let result = new Date(epoch);
            return result;
        },

        clone(source) {
            let str = JSON.stringify(source);
            let result = JSON.parse(str);
            return result;
        },

        cutOffEmoji(input) {
            if (!input) {
                return input;
            }

            //let oldExpression = /\p{Emoji}+/gu;
            let result = input.replaceAll(officialEmojiExpression(), '')
                .replaceAll(unofficialEmojiExpression(), '');
            return result;
        },

        cutEdges(str) {
            const result = str.substring(1, str.length - 1);
            return result;
        },

        getChromeVersion() {
            try {
                let result = /Chrome\/([0-9.]+)/.exec(navigator.userAgent)[1];
                return result;
            } catch {
                return "<unknown>";
            }
        },

        // brackets are not escaped by default  https://developer.mozilla.org/en-US/docs/web/javascript/reference/global_objects/encodeuricomponent
        // they must be escaped
        customEncodeUri(source) {
            let result = encodeURIComponent(source);
            result = result.replaceAll('(', '%28');
            result = result.replaceAll(')', '%29');
            return result;
        },

        customDecodeUri(source) {
            let result = decodeURIComponent(source);
            return result;
        }

    };
})();

const metadataFactory = (function () {

    const factoryResult = {

        create () {
            let result = {
                correlationId: crypto.randomUUID()
            };
            return result;
        }
    };

    return factoryResult;
})();

const backendTopics = {
    export: "export",
    global: "global",
    tabMessage: "tabMessage",
    apiProxy: "apiProxy",
    linkedInProxy: "linkedInProxy",
    linkedInProxyV2: "linkedInProxyV2",
    linkedInProxyHeaders: "linkedInProxyHeaders",
    linkedInService: "linkedInService",
    linkedInVoyagerSpy: "linkedInVoyagerSpy",
    linkedInHeadersRewriter: "linkedInHeadersRewriter",
    salesNavigatorProxy: "salesNavigatorProxy",
    salesNavigatorService: "salesNavigatorService",
    salesNavigatorVoyagerSpy: "salesNavigatorVoyagerSpy",
    oauth: "oauth",
    logging: "logging",
    traceableRequests: "traceableRequests",
    scheduler: "scheduler",
    exportContacts: "exportContacts",
    system: "system",
    settings: "settings",
    localStorage: "localStorage",
    reliability: "reliability",
    campaignsRunner: "campaignsRunner",
    offscreen: "offscreen"
};

const backendCommandsFactory = (function () {

    const factoryResult = {

        system: {

            createGetExtensionSettings (metadata) {
                let result = {
                    target: backendTopics.system,
                    command: "getExtensionSettings",
                    args: {
                        metadata
                    },
                    skipTracing: true
                };
                return result;
            }
        },

        settings: {

            createGetApplicationsSettings (metadata) {
                let result = {
                    target: backendTopics.settings,
                    command: "getApplicationsSettings",
                    args: {
                        metadata
                    }
                };
                return result;
            }
        },

        apiProxy: {

            createCreateExportTag (name, type, exportMetadata, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "createExportTag",
                    args: {
                        parameter: {
                            name,
                            type,
                            metadata: exportMetadata
                        },
                        metadata
                    }
                };
                return result;
            },

            createExportTaggedContacts (tagId, contacts, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "exportTaggedContacts",
                    args: {
                        parameter: {
                            tagId,
                            contacts
                        },
                        metadata
                    },
                };
                return result;
            },

            createAddMetadataToTag (tagId, exportMetadata, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "addMetadataToTag",
                    args: {
                        parameter: {
                            tagId,
                            metadata: exportMetadata
                        },
                        metadata
                    }
                };
                return result;
            },

            createSyncConversations (conversations, timestamp, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "syncConversations",
                    args: {
                        parameter: {
                            conversations,
                            timestamp
                        },
                        metadata
                    }
                };
                return result;
            },

            createSyncConnections (connections, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "syncConnections",
                    args: {
                        parameter: {
                            connections
                        },
                        metadata
                    }
                };
                return result;
            },

            createSyncContact (contactId, contact, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "syncContact",
                    args: {
                        parameter: {
                            contactId,
                            contact
                        },
                        metadata
                    }
                };
                return result;
            },

            createGetNextOperations (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getNextOperations",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetOperation (campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getOperation",
                    args: {
                        parameter: {
                            campaignExecutionId,
                            stepNumber
                        },
                        metadata
                    }
                };
                return result;
            },

            createGetWithdrawOperations (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getWithdrawOperations",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createStepExecuted (campaignId, campaignExecutionId, stepNumber, actionResult, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepExecuted",
                    args: {
                        parameter: {
                            campaignId,
                            campaignExecutionId,
                            stepNumber,
                            actionResult
                        },
                        metadata
                    }
                };
                return result;
            },

            createStepError (campaignId, campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepExecutionError",
                    args: {
                        parameter: {
                            campaignId,
                            campaignExecutionId,
                            stepNumber
                        },
                        metadata
                    }
                };
                return result;
            },

            createStepSkipped (campaignId, campaignExecutionId, stepNumber, reason, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepSkipped",
                    args: {
                        parameter: {
                            campaignId,
                            campaignExecutionId,
                            stepNumber,
                            reason
                        },
                        metadata
                    }
                };
                return result;
            },

            createStepWithdrawn (campaignId, campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepWithdrawn",
                    args: {
                        parameter: {
                            campaignId,
                            campaignExecutionId,
                            stepNumber
                        },
                        metadata
                    }
                };
                return result;
            },

            createStepWithdrawError (campaignId, campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "stepWithdrawError",
                    args: {
                        parameter: {
                            campaignId,
                            campaignExecutionId,
                            stepNumber
                        },
                        metadata
                    }
                };
                return result;
            },

            createReportExceedLimit (operationType, code, campaignId, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "reportExceedLimit",
                    args: {
                        parameter: {
                            operationType,
                            code,
                            campaignId
                        },
                        metadata
                    }
                };
                return result;
            },

            createGetMyProfile (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getMyProfile",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createAddLinkedInProfile (linkedInProfile, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "addLinkedInProfile",
                    args: {
                        parameter: {
                            linkedInProfile
                        },
                        metadata
                    }
                };
                return result;
            },

            createGetLinkedInProfiles (metadata) {
                const result = {
                    target: backendTopics.apiProxy,
                    command: "getLinkedInProfiles",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetWorkingHours (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getWorkingHours",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createSetRunningActivities (state, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "setRunningActivities",
                    args: {
                        parameter: {
                            state
                        },
                        metadata
                    }

                };
                return result;
            },

            createRefreshCampaignExecutions (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "refreshCampaignExecutions",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createEndAutomationRun (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "endAutomationRun",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createExchangeAuthorizationCode (code, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "exchangeAuthorizationCode",
                    args: {
                        parameter: {
                            code
                        },
                        metadata
                    }
                };
                return result;
            },

            createSwitchToWorkspace (linkedInProfileId, metadata) {
                const result = {
                    target: backendTopics.apiProxy,
                    command: "switchToWorkspace",
                    args: {
                        parameter: {
                            linkedInProfileId
                        },
                        metadata
                    }
                };
                return result;
            },

            createRevokeToken (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "revokeToken",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetRecentExports (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getRecentExports",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createReportLogEntry (logEventId, severity, message, args, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "reportLogEntry",
                    args: {
                        parameter: {
                            logEventId,
                            severity,
                            message,
                            args
                        },
                        metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createRefreshAuthTokens (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "refreshAuthTokens",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetAccessToken (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getAccessToken",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createIsCompatibleWithCurrentExtension (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "isCompatibleWithCurrentExtension",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createExtensionDetected (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "extensionDetected",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createSetWorkingHours (workingHours, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "setWorkingHours",
                    args: {
                        parameter: {
                            workingHours
                        },
                        metadata
                    }
                };
                return result;
            },

            createSignInUnderTeamMember (personaId, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "signInUnderTeamMember",
                    args: {
                        parameter: {
                            personaId
                        },
                        metadata
                    }
                };
                return result;
            },

            createSignOutUnderTeamMember (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "signOutUnderTeamMember",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetCurrentDateTime (metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "getCurrentDateTime",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createCreateLinkedInTrackingId (uuid, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "createLinkedInTrackingId",
                    args: {
                        parameter: {
                            uuid
                        },
                        metadata
                    }
                };
                return result;
            },

            createReportCustomMessageTooLong (campaignId, campaignExecutionId, stepNumber, metadata) {
                let result = {
                    target: backendTopics.apiProxy,
                    command: "reportCustomMessageTooLong",
                    args: {
                        parameter: {
                            campaignId,
                            campaignExecutionId,
                            stepNumber
                        },
                        metadata
                    }
                };
                return result;
            },

            backendAutomation: {

                createSaveLinkedinHeaders (linkedIn, salesNavigator, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "saveLinkedinHeaders",
                        args: {
                            parameter: {
                                linkedIn,
                                salesNavigator
                            },
                            metadata
                        }
                    };
                    return result;
                },

                createGetCurrentProfile (linkedInHeaders,  metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getCurrentLinkedInProfile",
                        args: {
                            parameter: {
                                linkedIn: linkedInHeaders
                            },
                            metadata
                        }
                    };
                    return result;
                },

                createGetLinkedInContactsFromSearchPage (searchRequest, referrer, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getLinkedInContactsFromSearchPage",
                        args: {
                            parameter: {
                                searchRequest,
                                referrer
                            },
                            metadata
                        }
                    };
                    return result;
                },

                createGetLinkedInContactsFromGroupPage (searchRequest, typeaheadQuery, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getLinkedInContactsFromGroupPage",
                        args: {
                            parameter: {
                                searchRequest,
                                typeaheadQuery
                            },
                            metadata
                        }
                    };
                    return result;
                },

                createGetSalesNavigatorContactsFromSearchPage (searchRequest, referer, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getSalesNavigatorContactsFromSearchPage",
                        args: {
                            parameter: {
                                searchRequest,
                                referer
                            },
                            metadata
                        }
                    };
                    return result;
                },

                createGetSalesNavigatorContactsFromLeadsList (searchRequest, referer, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getSalesNavigatorContactsFromLeadsList",
                        args: {
                            parameter: {
                                searchRequest,
                                referer
                            },
                            metadata
                        }
                    };
                    return result;
                },

                createGetContact (id, metadata) {
                    let result = {
                        target: backendTopics.apiProxy,
                        command: "getContact",
                        args: {
                            parameter: {
                                id
                            },
                            metadata
                        }
                    };
                    return result;
                }
            }
        },

        linkedInProxy: {

            authorize: {
                V2: {

                    createTypeInConversation (conversationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "typeInConversation",
                            args: {
                                parameter: {
                                    conversationId,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetContactActions (id, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactActions",
                            args: {
                                parameter: {
                                    id,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetConnections (start, count, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConnections",
                            args: {
                                parameter: {
                                    start,
                                    count,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetCurrentProfile (headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getCurrentProfile",
                            args: {
                                parameter: {
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetConversationEventsByCursor (selfEntityId, conversationId, prevCursor, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConversationEventsByCursor",
                            args: {
                                parameter: {
                                    selfEntityId,
                                    conversationId,
                                    prevCursor,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createUnfollowContact (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "unfollowContact",
                            args: {
                                parameter: {
                                    entityId,
                                    publicIdentifier,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createFollowContactTopPosts (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "followContactTopPosts",
                            args: {
                                parameter: {
                                    entityId,
                                    publicIdentifier,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createFollowContactAllPosts (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "followContactAllPosts",
                            args: {
                                parameter: {
                                    entityId,
                                    publicIdentifier,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createWithdrawInvitation (invitationId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "withdrawInvitation",
                            args: {
                                parameter: {
                                    invitationId,
                                    headers,
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createMarkConversationAsRead (conversationId, selfEntityId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "markConversationAsRead",
                            args: {
                                parameter: {
                                    conversationId,
                                    selfEntityId,
                                    headers,
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetContactsFromSearchPage (searchRequest, referrer, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactsFromSearchPage",
                            args: {
                                parameter: {
                                    searchRequest,
                                    referrer,
                                    headers,
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetContactsFromGroupPage (searchRequest, typeaheadQuery, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactsFromGroupPage",
                            args: {
                                parameter: {
                                    searchRequest,
                                    typeaheadQuery,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetContactLatestJobs (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactLatestJobs",
                            args: {
                                parameter: {
                                    entityId,
                                    publicIdentifier,
                                    headers,
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetContactMiniProfile (id, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactMiniProfile",
                            args: {
                                parameter: {
                                    id,
                                    headers,
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createReactOnContactPost (postEntityId, postType, publicIdentifier, reaction, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "reactOnContactPost",
                            args: {
                                parameter: {
                                    postEntityId,
                                    postType,
                                    publicIdentifier,
                                    reaction,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetContactRecentPosts (entityId, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getContactRecentPosts",
                            args: {
                                parameter: {
                                    entityId,
                                    publicIdentifier,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createCreateConversation (selfEntityId, recipientEntityId, message, trackingId, recipientId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "createConversation",
                            args: {
                                parameter: {
                                    selfEntityId,
                                    recipientEntityId,
                                    message,
                                    trackingId,
                                    recipientId,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetConversationsByLastUpdatedBefore (selfEntityId, createdBefore, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConversationsByLastUpdatedBefore",
                            args: {
                                parameter: {
                                    selfEntityId,
                                    createdBefore,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetConversationsByCursor (selfEntityId, nextCursor, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConversationsByCursor",
                            args: {
                                parameter: {
                                    selfEntityId,
                                    nextCursor,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createCreateInvitation (entityId, message, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "createInvitation",
                            args: {
                                parameter: {
                                    entityId,
                                    message,
                                    publicIdentifier,
                                    headers,
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createCreateConversationEvent (selfEntityId, conversationId, message, trackingId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "createConversationEvent",
                            args: {
                                parameter: {
                                    selfEntityId,
                                    conversationId,
                                    message,
                                    trackingId,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetConversationRecentEvents (selfEntityId, conversationId, deliveredAt, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getConversationRecentEvents",
                            args: {
                                parameter: {
                                    selfEntityId,
                                    conversationId,
                                    deliveredAt,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetFirstContactSkills (publicIdentifier, entityId, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getFirstContactSkills",
                            args: {
                                parameter: {
                                    publicIdentifier,
                                    entityId,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createGetNextContactSkills (listComponent, includeMetadata, start, count, publicIdentifier, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "getNextContactSkills",
                            args: {
                                parameter: {
                                    listComponent,
                                    includeMetadata,
                                    start,
                                    count,
                                    publicIdentifier,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    },

                    createEndorseContactSkill (publicIdentifier, profileEndorsedSkill, headers, metadata) {
                        let result = {
                            target: backendTopics.linkedInProxyV2,
                            command: "endorseContactSkill",
                            args: {
                                parameter: {
                                    publicIdentifier,
                                    profileEndorsedSkill,
                                    headers
                                },
                                metadata
                            }
                        };
                        return result;
                    }
                },
            },

            headers: {

                createGetLastLinkedInRequestHeaders (metadata) {
                    let result = {
                        target: backendTopics.linkedInProxyHeaders,
                        command: "getLastLinkedInRequestHeaders",
                        args: {
                            metadata
                        }
                    };
                    return result;
                },

                createGetLastSalesNavigatorRequestHeaders (metadata) {
                    let result = {
                        target: backendTopics.linkedInProxyHeaders,
                        command: "getLastSalesNavigatorRequestHeaders",
                        args: {
                            metadata
                        }
                    };
                    return result;
                }
            }

        },

        linkedInService: {

            createGetContactsFromSearchPage (searchRequest, referrer, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getContactsFromSearchPage",
                    args: {
                        parameter: {
                            searchRequest,
                            referrer
                        },
                        metadata
                    }
                };
                return result;
            },

            createGetContactsFromGroupPage (searchRequest, typeaheadQuery, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getContactsFromGroupPage",
                    args: {
                        parameter: {
                            searchRequest,
                            typeaheadQuery
                        },
                        metadata
                    }
                };
                return result;
            },

            createReadNewConnections (connectedAfter, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "readNewConnections",
                    args: {
                        parameter: {
                            connectedAfter
                        },
                        metadata
                    }
                };
                return result;
            },

            createReadNewConversations (createdAfter, createdBefore, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "readNewConversations",
                    args: {
                        parameter: {
                            createdAfter,
                            createdBefore
                        },
                        metadata
                    }
                };
                return result;
            },

            createSendMessage (publicIdentifier, entityId, message, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "sendMessage",
                    args: {
                        parameter: {
                            publicIdentifier,
                            entityId,
                            message
                        },
                        metadata
                    }
                };
                return result;
            },

            createConnect (publicIdentifier, entityId, message, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "connect",
                    args: {
                        parameter: {
                            publicIdentifier,
                            entityId,
                            message
                        },
                        metadata
                    }
                };
                return result;
            },

            createWithdraw (invitationId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "withdraw",
                    args: {
                        parameter: {
                            invitationId
                        },
                        metadata
                    }
                };
                return result;
            },

            createGetContactFullProfile (id, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getContactFullProfile",
                    args: {
                        parameter: {
                            id
                        },
                        metadata
                    }
                };
                return result;
            },

            createGetCurrentProfile (metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "getCurrentProfile",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createFollow (publicIdentifier, entityId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "follow",
                    args: {
                        parameter: {
                            publicIdentifier,
                            entityId
                        },
                        metadata
                    }
                };
                return result;
            },

            createReactOnRecentContactPost (publicIdentifier, entityId, reaction, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "reactOnRecentContactPost",
                    args: {
                        parameter: {
                            publicIdentifier,
                            reaction,
                            entityId
                        },
                        metadata
                    }
                };
                return result;
            },

            createEndorseMostPopularContactSkill (publicIdentifier, entityId, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "endorseMostPopularContactSkill",
                    args: {
                        parameter: {
                            publicIdentifier,
                            entityId
                        },
                        metadata
                    }
                };
                return result;
            },

            createNormalize (miniProfile, metadata) {
                let result = {
                    target: backendTopics.linkedInService,
                    command: "normalize",
                    args: {
                        parameter: {
                            miniProfile
                        },
                        metadata
                    }
                };
                return result;
            },

        },

        linkedInVoyagerSpy: {

            createResetCache (metadata) {
                let result = {
                    target: backendTopics.linkedInVoyagerSpy,
                    command: "resetCache",
                    args: {
                        metadata
                    }
                };
                return result;
            }
        },

        linkedInHeadersRewriter: {

            createSetReferer (referrer, metadata) {
                let result = {
                    target: backendTopics.linkedInHeadersRewriter,
                    command: "setReferer",
                    args: {
                        parameter: {
                            referrer
                        },
                        metadata
                    }
                };
                return result;
            },

            createResetReferer (metadata) {
                let result = {
                    target: backendTopics.linkedInHeadersRewriter,
                    command: "resetReferer",
                    args: {
                        metadata
                    }
                };
                return result;
            }

        },

        salesNavigatorProxy: {

            authorize: {

                createGetContactsFromSearchPage (searchRequest, referer, headers, metadata) {
                    let result = {
                        target: backendTopics.salesNavigatorProxy,
                        command: "getContactsFromSearchPage",
                        args: {
                            parameter: {
                                searchRequest,
                                referer,
                                headers
                            },
                            metadata
                        }
                    };
                    return result;
                },

                createGetContactsFromLeadsList (searchRequest, referer, headers, metadata) {
                    let result = {
                        target: backendTopics.salesNavigatorProxy,
                        command: "getContactsFromLeadsList",
                        args: {
                            parameter: {
                                searchRequest,
                                referer,
                                headers
                            },
                            metadata
                        }
                    };
                    return result;
                }

            }

        },

        salesNavigatorService: {

            createGetContactsFromSearchPage (searchRequest, referer, metadata) {
                let result = {
                    target: backendTopics.salesNavigatorService,
                    command: "getContactsFromSearchPage",
                    args: {
                        parameter: {
                            searchRequest,
                            referer
                        },
                        metadata
                    }
                };
                return result;
            },

            createGetContactsFromLeadsList (searchRequest, referer, metadata) {
                let result = {
                    target: backendTopics.salesNavigatorService,
                    command: "getContactsFromLeadsList",
                    args: {
                        parameter: {
                            searchRequest,
                            referer
                        },
                        metadata
                    }
                };
                return result;
            },
        },

        auth: {

            createSignOut (metadata) {
                let result = {
                    target: backendTopics.oauth,
                    command: "signOut",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetSignInUri (state, referrer, metadata) {
                let result = {
                    target: backendTopics.oauth,
                    command: "getSigninUri",
                    args: {
                        parameter: {
                            state,
                            referrer,
                        },
                        metadata
                    }
                };
                return result;
            }

        },

        localStorage: {

            createGetSnailyProfile (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getSnailyProfile",
                    args: {
                        metadata,
                        checkSignedInLinkedInUser: true
                    }
                };
                return result;
            },

            createGetLatestKnownSnailyProfile (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getLatestKnownSnailyProfile",
                    args: {
                        metadata,
                        checkSignedInLinkedInUser: false
                    }
                };
                return result;
            },

            createGetUserLogLevel (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getUserLogLevel",
                    args: {
                        metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createGetLinkedInProfile (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getLinkedInProfile",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetSignedInPersonaJwtTokens (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getSignedInPersonaJwtTokens",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetSignedInLinkedInUser (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getSignedInLinkedInUser",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createSaveSignedInPersonaJwtTokens (jwtTokens, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "saveSignedInPersonaJwtTokens",
                    args: {
                        parameter: {
                            jwtTokens
                        },
                        metadata
                    }
                };
                return result;
            },

            createDeleteSignedInPersonaJwtTokens (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "deleteSignedInPersonaJwtTokens",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetImpersonatedPersonaJwtTokens (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getImpersonatedPersonaJwtTokens",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createSaveImpersonatedPersonaJwtTokens (jwtTokens, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "saveImpersonatedPersonaJwtTokens",
                    args: {
                        parameter: {
                            jwtTokens
                        },
                        metadata
                    }
                };
                return result;
            },

            createDeleteImpersonatedPersonaJwtTokens (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "deleteImpersonatedPersonaJwtTokens",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetPendingCommands (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getPendingCommands",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createSavePendingCommands (commands, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "savePendingCommands",
                    args: {
                        parameter: {
                            commands
                        },
                        metadata
                    }
                };
                return result;
            },

            createDeletePendingCommands (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "deletePendingCommands",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetLinkedInHeaders (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getLinkedInHeaders",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createSaveLinkedInHeaders (headers, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "saveLinkedInHeaders",
                    args: {
                        parameter: {
                            headers
                        },
                        metadata
                    }
                };
                return result;
            },

            createGetSalesNavigatorHeaders (metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "getSalesNavigatorHeaders",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createSaveSalesNavigatorHeaders (headers, metadata) {
                let result = {
                    target: backendTopics.localStorage,
                    command: "saveSalesNavigatorHeaders",
                    args: {
                        parameter: {
                            headers
                        },
                        metadata
                    }
                };
                return result;
            },

        },

        automation: {

            createGetExportState (metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "getState",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createStartCsvExport (type, publicIdentifiers, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "start",
                    args: {
                        parameter: {
                            type,
                            details: {
                                publicIdentifiers
                            }
                        },
                        metadata
                    }
                };
                return result;
            },

            createStartCsvContactsExport (type, contacts, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "start",
                    args: {
                        parameter: {
                            type,
                            details: {
                                contacts
                            }
                        },
                        metadata
                    }
                };
                return result;
            },

            createStartExportContactsFromUrl (tabId, type, url, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "start",
                    args: {
                        parameter: {
                            tabId,
                            type,
                            details: {
                                url
                            }
                        },
                        metadata
                    }
                };
                return result;
            },

            createStopExport (metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "stop",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createClearExport (metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "clear",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createGetExportHref (exportId, metadata) {
                let result = {
                    target: backendTopics.exportContacts,
                    command: "getExportHref",
                    args: {
                        parameter: {
                            exportId
                        },
                        metadata
                    }
                };
                return result;
            }

        },

        browser: {

            createGetTabInfo (tabId, metadata) {
                let result = {
                    target: backendTopics.global,
                    command: 'getTabInfoAsync',
                    args: {
                        parameter: {
                            tabId
                        },
                        metadata
                    }
                };
                return result;
            },

            createTabMessage (tabId, message, metadata) {
                let result = {
                    target: backendTopics.tabMessage,
                    command: "sendMessage",
                    args: {
                        parameter: {
                            tabId,
                            message
                        },
                        metadata
                    }
                };
                return result;
            }
        },

        logging: {

            createLogError (logEntryId, parameters, metadata) {
                let result = {
                    target: backendTopics.logging,
                    command: "logError",
                    args: {
                        parameter: {
                            logEntryId,
                            parameters
                        },
                        metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createLogTrace (logEntryId, parameters, metadata) {
                let result = {
                    target: backendTopics.logging,
                    command: "logTrace",
                    args: {
                        parameter: {
                            logEntryId,
                            parameters
                        },
                        metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createLogInformation (logEntryId, parameters, metadata) {
                let result = {
                    target: backendTopics.logging,
                    command: "logInformation",
                    args: {
                        parameter: {
                            logEntryId,
                            parameters
                        },
                        metadata
                    },
                    skipTracing: true
                };
                return result;
            },

            createLogWaring (logEntryId, parameters, metadata) {
                let result = {
                    target: backendTopics.logging,
                    command: "logWarning",
                    args: {
                        parameter: {
                            logEntryId,
                            parameters
                        },
                        metadata
                    },
                    skipTracing: true
                };
                return result;
            }
        },

        traceable: {

            createHttpRequest (uri, requestInit, metadata) {
                let result = {
                    target: backendTopics.traceableRequests,
                    command: "httpRequest",
                    args: {
                        parameter: {
                            uri,
                            requestInit
                        },
                        metadata
                    },
                    skipTracing: true
                };
                return result;
            }

        },

        reliability: {

            createResendPendingCommandsIfAny (metadata) {
                let result = {
                    target: backendTopics.reliability,
                    command: "resendPendingCommandsIfAny",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createReliablePublish (command, metadata) {
                let result = {
                    target: backendTopics.reliability,
                    command: "reliablePublish",
                    args: {
                        parameter: {
                            command
                        },
                        metadata
                    }
                };
                return result;
            }
        },

        campaignsRunner: {

            createIsInWorkingHours (metadata) {
                let result = {
                    target: backendTopics.campaignsRunner,
                    command: "isInWorkingHours",
                    args: {
                        metadata
                    }
                };
                return result;
            },
        },

        // these commands are needed only in development
        offScreen: {

            isUpdateAvailable (metadata) {
                let result = {
                    target: backendTopics.offscreen,
                    command: "isUpdateAvailable",
                    args: {
                        metadata
                    }
                };
                return result;
            },

            createUpdateAvailable (metadata) {
                let result = {
                    target: backendTopics.offscreen,
                    command: "updateAvailable",
                    args: {
                        metadata
                    }
                };
                return result;
            },
        }
    };

    return factoryResult;

})();

class ExtensionRuntimeError extends SnailyError {

    constructor(message, request, metadata) {
        super(message, request, metadata);
        this.name = "ExtensionRuntimeError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ExtensionRuntimeError);
        }
    }

    toString() {
        let result = `${super.toString()}; Request: ${JSON.stringify(this.request)}`;
        return result;
    }
}

/**
 * This error happens when there is no handler for a message.
 * It could happens when popup is closed and backendBroker fires an event.
 */
class MissingReceiverExtensionRuntimeError extends ExtensionRuntimeError {

    constructor(message, request, metadata) {
        super(message, request, metadata);
        this.name = "MissingReceiverExtensionRuntimeError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, MissingReceiverExtensionRuntimeError);
        }
    }

    get skipLogging() {
        return true;
    }
}

/**
 * This error happens when handler ends execution before sendResponse is called.
 * It is most likely improper implementation , see details https://developer.chrome.com/docs/extensions/mv2/messaging/
 */

class PortClosedExtensionRuntimeError extends ExtensionRuntimeError {

    constructor(message, request, metadata) {
        super(message, request, metadata);
        this.name = "PortClosedExtensionRuntimeError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PortClosedExtensionRuntimeError);
        }
    }

    get skipLogging() {
        return true;
    }
}

const runtimeErrorsFactory = (function () {

    const factory = {

        create (message, stackTrace, request, metadata) {
            let result;
            if (message === "Could not establish connection. Receiving end does not exist.") {
                result = new MissingReceiverExtensionRuntimeError(message, request, metadata);
            } else if (message === "The message port closed before a response was received.") {
                result = new PortClosedExtensionRuntimeError(message, request, metadata);
            } else {
                result = new ExtensionRuntimeError(message, request, metadata);
            }

            if (stackTrace) {
                result.stack += `\n Inner async invocation \n ${stackTrace} \n`;
            }
            return result;
        }
    };
    return factory;

})();

class BadGatewayError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "BadGatewayError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BadGatewayError);
        }
    }

    get skipLogging() {
        return true;
    }

}

class NotAuthenticatedError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "NotAuthenticatedError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotAuthenticatedError);
        }
    }

}

class NotAuthorizedError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "NotAuthorizedError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NotAuthorizedError);
        }
    }

}

class BadRequestError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "BadRequestError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, BadRequestError);
        }
    }

}

class ProxyAuthenticationRequiredError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ProxyAuthenticationRequiredError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ProxyAuthenticationRequiredError);
        }
    }

}

class UnprocessableEntityError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "UnprocessableEntityError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UnprocessableEntityError);
        }
    }

}

class EmptySearchPageError extends SnailyError {

    constructor(response, metadata) {
        super(response.statusText, metadata);
        this.name = "EmptySearchPageError";
        this.url = response.url;

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, EmptySearchPageError);
        }
    }
}

class OldExtensionError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "OldExtensionError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, OldExtensionError);
        }
    }

}

class SnailySignInRequiredError extends SnailyError {

    constructor(body, metadata) {
        super(body, metadata);
        this.name = "SnailySignInRequiredError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, SnailySignInRequiredError);
        }
    }

}

class LinkedInSignInRequiredError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "LinkedInSignInRequiredError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, LinkedInSignInRequiredError);
        }
    }

}

class LinkedInProfileAlreadyUsedError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "LinkedInProfileAlreadyUsedError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, LinkedInProfileAlreadyUsedError);
        }
    }

    get skipLogging() {
        return true;
    }

}

class InvalidOperationError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "InvalidOperationError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, InvalidOperationError);
        }
    }
    
}

const errorsFactory = (function () {

    const result = {

        create (input, innerStackTrace, metadata) {

            let result;
            switch (input.name) {

                case 'BadGatewayError':
                    result = new BadGatewayError(input.message, metadata);
                    break;

                case 'NotAuthenticatedError':
                    result = new NotAuthenticatedError(input.message, metadata);
                    break;

                case 'NotAuthorizedError':
                    result = new NotAuthorizedError(input.message, metadata);
                    break;

                case 'BadRequestError':
                    result = new BadRequestError(input.message, metadata);
                    break;

                case 'ProxyAuthenticationRequiredError':
                    result = new ProxyAuthenticationRequiredError(input.message, metadata);
                    break;

                case 'UnprocessableEntityError':
                    result = new UnprocessableEntityError(input.message, metadata);
                    break;

                case 'EmptySearchPageError':
                    result = new EmptySearchPageError(input.message, metadata);
                    break;

                case 'MissingReceiverExtensionRuntimeError':
                    result = new MissingReceiverExtensionRuntimeError(input.message, metadata);
                    break;

                case 'PortClosedExtensionRuntimeError':
                    result = new PortClosedExtensionRuntimeError(input.message, metadata);
                    break;

                case 'ExtensionRuntimeError':
                    result = new ExtensionRuntimeError(input.message, metadata);
                    break;

                case 'OldExtensionError':
                    result = new OldExtensionError(input.message, metadata);
                    break;

                case 'SnailySignInRequiredError':
                    result = new SnailySignInRequiredError(input.message, metadata);
                    break;

                case 'LinkedInSignInRequiredError':
                    result = new LinkedInSignInRequiredError(input.message, metadata);
                    break;

                case 'LinkedInProfileAlreadyUsedError':
                    result = new LinkedInProfileAlreadyUsedError(input.message, metadata);
                    break;

                default:
                    result = new InvalidOperationError(input.message, metadata);
            }

            result.stack += `\n Original invocation ${input.stack}\n`;
            if (innerStackTrace) {
                result.stack += `\n Inner async invocation \n ${innerStackTrace} \n`;
            }

            return result;
        },

    };
    return result;

})();

class SnailyPromise extends Promise {

    constructor(callback) {
        let temp = {};
        Error.captureStackTrace(temp, SnailyPromise);
        const stackTrace = utils.cutFirstLine(temp.stack);

        const wrappedCallback = function (resolve, reject) {
            try {
                callback(resolve, function (e) {
                    if (utils.isJson(e)) {
                        if (e.stack) {
                            e.stack = e.stack + "\n" + stackTrace + "\n";
                        } else {
                            e.stack = stackTrace;
                        }
                    }
                    reject(e);
                });
            } catch (exp) {
                //ToDo;
                throw exp;
            }
        };
        super(wrappedCallback);
    }

    catch(...args) {
        let data = super.catch(...args);
        return data;
    }
}

class ClientError extends SnailyError {

    constructor(message, metadata) {
        super(message, metadata);
        this.name = "ClientError";

        // noinspection JSUnresolvedVariable
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ClientError);
        }
    }
}

class ChromeRuntimeAdapter {
    async sendMessage(command) {
        let innerStackTrace = utils.getStackTrace();
        const result = await new SnailyPromise(function (resolve, reject) {
            try {
                chrome.runtime.sendMessage(
                    command,
                    function (response) {
                        let error;
                        if (chrome.runtime.lastError) {
                            error = runtimeErrorsFactory.create(chrome.runtime.lastError.message, innerStackTrace, command, command.args.metadata);
                            reject(error);
                            //need to distinguish null and  undefined
                        } else if (response) {
                            //ToDo: might be something more explicit
                            if (response.error) {
                                error = errorsFactory.create(response.error, innerStackTrace, command.args.metadata);
                                reject(error);
                            } else {
                                resolve(response);
                            }
                        } else {
                            resolve(null);
                        }
                    });
            } catch (exp) {
                //this could happens when extension is reloaded
                const error = runtimeErrorsFactory.create(exp.message, innerStackTrace, command, command.args.metadata);
                reject(error);
            }
        });
        return result;
    }

    async sendTabMessage(args) {
        let innerStackTrace = utils.getStackTrace();
        const result = await new SnailyPromise(function (resolve, reject) {
            try {
                chrome.tabs.sendMessage(args.parameter.tabId,
                    args.parameter.message,
                    function (response) {
                        //need to distinguish null and  undefined
                        if (!chrome.runtime.lastError) {
                            //ToDo: might be something more explicit
                            if (response && response.error) {

                                const innerError = new Error(response.error.message);
                                innerError.stack = response.error.stack;
                                let errorMessage = utils.toString(innerError);

                                let clientError = new ClientError(errorMessage, args, args.metadata);
                                clientError.stack += `\n Inner Error \n ${innerStackTrace} \n`;
                                reject(clientError);

                            } else {
                                resolve(response);
                            }
                        } else {
                            let error = runtimeErrorsFactory.create(chrome.runtime.lastError.message, innerStackTrace, args, args.metadata);
                            reject(error);
                        }
                    });
            } catch (exp) {
                //this could happens when extension is reloaded
                const error = runtimeErrorsFactory.create(exp.message, innerStackTrace, args, args.metadata);
                reject(error);
            }
        });
        return result;
    }

    async sendExtensionMessage(extensionId, message) {
        let innerStackTrace = utils.getStackTrace();
        const result = await new SnailyPromise(function (resolve, reject) {
            try {
                chrome.runtime.sendMessage(
                    extensionId,
                    message,
                    function (response) {
                        let error;
                        if (chrome.runtime.lastError) {
                            error = runtimeErrorsFactory.create(chrome.runtime.lastError.message, innerStackTrace, message, message.args.metadata);
                            reject(error);
                            //need to distinguish null and  undefined
                        } else if (response !== undefined && response !== null) {
                            //ToDo: might be something more explicit
                            if (response.error) {
                                error = errorsFactory.create(response.error, innerStackTrace, message.args.metadata);
                                reject(error);
                            } else {
                                resolve(response);
                            }
                        } else {
                            resolve(null);
                        }
                    });
            } catch (exp) {
                //this could happens when extension is reloaded
                const error = runtimeErrorsFactory.create(exp.message, innerStackTrace, message, message.args.metadata);
                reject(error);
            }
        });
        return result;
    }

    async createTab(url) {
        let tabInfo = {
            url
        };
        let result = await new SnailyPromise(function (resolve) {
            chrome.tabs.create(tabInfo,
                function (tab) {
                    resolve(tab);
                });
        });
        return result;
    }

    async clearAlarm(name) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.alarms.clear(name,
                function (wasCleared) {
                    resolve(wasCleared);
                });
        });
        return result;
    }

    async getAlarm(name) {
        const result = await new SnailyPromise(function (resolve) {
            chrome.alarms.get(name,
                function (alarm) {
                    resolve(alarm);
                });
        });
        return result;
    }

    async getSelectedTab() {
        let queryOptions = {active: true, lastFocusedWindow: true};
        // `tab` will either be a `tabs.Tab` instance or `undefined`.
        let [tab] = await chrome.tabs.query(queryOptions);
        return tab;
    }

    async getTab(id) {
        const result = await new SnailyPromise(function (resolve) {
            chrome.tabs.get(id,
                function (tab) {
                    resolve(tab);
                });
        });
        return result;
    }

    async reloadTab(id) {
        await new SnailyPromise(function (resolve) {
            chrome.tabs.reload(id, {}, resolve);
        });
    }

    async queryTabs() {
        let result = await new SnailyPromise(function (resolve) {
            chrome.tabs.query({},
                function (tabs) {
                    resolve(tabs);
                });
        });
        return result;
    }

    async createAlarm(name, delayInMinutes, periodInMinutes) {
        let alarmInfo = {delayInMinutes, periodInMinutes};
        await chrome.alarms.create(name, alarmInfo);
    }

    async createNotification(notificationId, options) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.notifications.create(notificationId,
                options,
                function (id) {
                    resolve(id);
                });
        });
        return result;
    }

    async setIcon(path) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.action.setIcon({path},
                function () {
                    resolve();
                });
        });
        return result;
    }

    async setBadgeText(text) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.action.setBadgeText({text},
                function () {
                    resolve();
                });
        });
        return result;
    }

    async setBadgeBackgroundColor(color) {
        let result = await new SnailyPromise(function (resolve) {
            chrome.action.setBadgeBackgroundColor({color},
                function () {
                    resolve();
                });
        });
        return result;
    }

    async getProxyConfig() {
        let result = await new SnailyPromise(function (resolve) {
            chrome.proxy.settings.get({'incognito': false},
                function (config) {
                    resolve(config);
                });
        });
        return result;
    }

    async setProxyConfig(proxyConfig) {
        await new SnailyPromise(function (resolve) {
            chrome.proxy.settings.set(
                {value: proxyConfig, scope: 'regular'}, () => {
                    resolve();
                });
        });
    }

    async clearProxyConfig() {
        await new SnailyPromise(function (resolve) {
            chrome.proxy.settings.clear({scope: 'regular'},
                function () {
                    resolve();
                });
        });
    }

    reload() {
        chrome.runtime.reload();
    }

    addOnMessageListener(listener) {
        chrome.runtime.onMessage.addListener(listener);
    }

    addOnExternalMessageListener(listener) {
        chrome.runtime.onMessageExternal.addListener(listener);
    }

    addAlarmListener(listener) {
        chrome.alarms.onAlarm.addListener(listener);
    }

    addOnInstalledListener(listener) {
        chrome.runtime.onInstalled.addListener(listener);
    }

    addOnStartupListener(listener) {
        chrome.runtime.onStartup.addListener(listener);
    }

    addOnTabRemovedListener(listener) {
        chrome.tabs.onRemoved.addListener(listener);
    }

    addOnTabCreatedListener(listener) {
        chrome.tabs.onCreated.addListener(listener);
    }

    addOnTabReplacedListener(listener) {
        chrome.tabs.onReplaced.addListener(listener);
    }

    addOnTabUpdatedListener(listener) {
        chrome.tabs.onUpdated.addListener(listener);
    }

    addOnWebRequestBeforeSendHeadersListener(listener, urls, options) {
        chrome.webRequest.onBeforeSendHeaders.addListener(listener, {urls}, options);
    }

    addOnWebRequestCompletedListener(listener, urls, options) {
        chrome.webRequest.onCompleted.addListener(listener, {urls}, options);
    }

    addOnWebRequestBeforeRedirectListener(listener, urls, options) {
        chrome.webRequest.onBeforeRedirect.addListener(listener, {urls}, options);
    }

    addOnWebRequestErrorOccurredListener(listener, urls, options) {
        chrome.webRequest.onErrorOccurred.addListener(listener, {urls}, options);
    }

    addOnNotificationButtonClickedListener(listener) {
        chrome.notifications.onButtonClicked.addListener(listener);
    }

    addOnNotificationClickedListener(listener) {
        chrome.notifications.onClicked.addListener(listener);
    }

    addOnUpdateAvailableListener(listener) {
        chrome.runtime.onUpdateAvailable.addListener(listener);
    }

    addOnProxyErrorListener(listener) {
        chrome.proxy.onProxyError.addListener(listener);
    }

    removeOnProxyErrorListener(listener) {
        chrome.proxy.onProxyError.removeListener(listener);
    }

    addOnAuthRequiredListener(listener, urls, options) {
        chrome.webRequest.onAuthRequired.addListener(listener, {urls}, options);
    }

    removeOnAuthRequiredListener(listener) {
        chrome.webRequest.onAuthRequired.removeListener(listener);
    }

    getName() {
        let result = chrome.runtime
            .getManifest()
            .name;
        return result;
    }

    getVersion() {
        let result = chrome.runtime
            .getManifest()
            .version;
        return result;
    }

    getId() {
        let result = chrome.runtime
            .id;
        return result;
    }

    async getLocalStorageItemAsync(key) {
        let storageItem = await chrome.storage.local.get([key]);
        let result = storageItem[key]
            ? storageItem[key]
            : null;
        return result;
    }

    async setLocalStorageItemAsync(key, value) {
        const json = {};
        json[key] = value;
        await chrome.storage.local.set(json);
    }

    async removeLocalStorageItemAsync(key) {
        await chrome.storage.local.remove(key);
    }

    async powerRequestSystemKeepAwake() {
        await chrome.power.requestKeepAwake("system");
    }

    async getAllCookies() {
        let details = {
            domain: "linkedin.com",
        };
        let result = await new SnailyPromise(function (resolve) {
            chrome.cookies.getAll(details, function (response) {
                resolve(response);
            });
        });
        return result;
    }

    async geCookies(name) {
        let details = {
            url: "https://www.linkedin.com",
            name
        };
        let result = await new SnailyPromise(function (resolve) {
            chrome.cookies.get(details, function (response) {
                resolve(response);
            });
        });
        return result;
    }
}

var runtimeAdapterFactory = function () {
    let result = new ChromeRuntimeAdapter();
    return result;
};

const eventNames = {
    exportStarting: 'exportStarting',
    exportStarted: 'exportStarted',
    exportCleared: 'exportCleared',
    exportChanged: 'exportChanged',
    exportFailed: 'exportFailed',
    exportCompleting: 'exportCompleting',
    exportCompleted: 'exportCompleted',
    snailySignedIn: 'snailySignedIn',
    snailySignedOut: 'snailySignedOut',
    snailyProfileChanged: 'snailyProfileChanged',
    linkedInSignedOut: 'linkedInSignedOut',
    linkedInProfileDetected: 'linkedInProfileDetected',
    automationScheduleTriggered: 'automationScheduleTriggered',
    automationScheduleDeleted: 'automationScheduleDeleted',
    automationScheduleCreated: 'automationScheduleCreated',
    automationEnded:'automationUpdated',
    extensionUpdating:"extensionUpdating",
    workingHoursChanged:"workingHoursChanged"
};

const contactsExportType = {
    linkedInContactsSearchPage: "LinkedInContactsSearchPageExport",
    linkedInGroupContactsPage: "LinkedInGroupContactsPageExport",
    salesNavigatorContactsSearchPage: "SalesNavigatorContactsSearchPageExport",
    salesNavigatorLeadsListPage: "SalesNavigatorLeadsListPageExport",
    contactsPublicIdentifierList: "ContactsPublicIdentifierListExport",
    csvContactsList: "CsvContactsListExport",
};

const logEntryIds = {
    unhandledError: 'ExtensionUnhandledError',
    exportError: 'ExtensionExportError',
    runExecutionsError: "ExtensionRunExecutionsError",
    backendBrokerError: "ExtensionBackendBrokerError",

    linkedInSignedOut: "LinkedInSignedOut",
    linkedInProfileDetected: "LinkedInProfileDetected",
    automationScheduleCreated: "AutomationScheduleCreated",
    automationScheduleDeleted: "AutomationScheduleDeleted",
    automationScheduleTriggered: "AutomationScheduleTriggered",
    automationUnexpectedlyStopped: "AutomationUnexpectedlyStopped",
    extensionUpdating: "ExtensionUpdating",
    traceRequest: "TraceRequest",
    traceRequestError: "TraceRequestError",
    clusterSearch: "ClusterSearch",
    emojiTracing: "EmojiTracing",
    incompleteJobTracing: "IncompleteJobTracing",
    notSupportedResponse: "NotSupportedResponse",
    noPosts: "NoPosts",
    extensionProxyError: "ExtensionProxyError",
    extensionStarted: "ExtensionStarted",
    cannotParsePremiumBadge: "CannotParsePremiumBadge",

    //linkedIn
    xliTrackInvalidFormatError: "XliTrackInvalidFormatError",

    //trace logs
    eventFired: "ExtensionEventFired",
    commandStarted: "ExtensionCommandStarted",
    commandEnded: "ExtensionCommandEnded"
};

const errorParametersFactory = (function () {

    const result = {
        create (error, event) {
            let parameters = {};
            if (error instanceof Error) {
                parameters.Message = error.message
                    ? `${error.name}: ${error.message}`
                    : error.name;
                parameters.StackTrace = utils.toString(error);
            } else {
                parameters.Message = utils.toString(error);
            }
            if (event) {
                error.event = event;
            }

            return parameters;
        }
    };

    return result;
})();

const phase = {
    none: 'none',
    lookingForDelimiter: 'lookingForDelimiter',
    lookingForDoubleQuotas: 'lookingForDoubleQuotas'
};

var csvLineParserFactory = function (source, delimiter) {
    let _source = !source
        ? ""
        : source.trim();
    let _delimiter = delimiter;
    let _lineBreak = '\n';
    let _doubleQuotas = '"';
    let _currentPhase = phase.none;
    let _startIndex = null;
    let _result = [];
    let _take = null;

    function setStartIndexIfNone(value) {
        if (!_startIndex) {
            _startIndex = value;
        }
    }

    function addField(field) {
        let trimmedField = field.trim();
        let normalizedField = trimmedField;
        if (field.length > 1) {
            if (field[0] === _doubleQuotas && field[field.length - 1] === _doubleQuotas) {
                normalizedField = utils.cutEdges(trimmedField);
            }
        }

        _result.push(normalizedField);

        _startIndex = null;
        _currentPhase = phase.none;

        let result = _take && _take <= _result.length;
        return result;
    }

    function parse(fromIndex, take) {
        _take = take;
        for (let i = fromIndex ?? 0; i <= _source.length - 1; i++) {
            let currentCharacter = _source[i];
            switch (currentCharacter) {
                case _delimiter:
                case _lineBreak:
                //case _carrierReturn:
                    if (_currentPhase === phase.none) {
                        let field = _startIndex
                            ? _source.substring(_startIndex, i)
                            : '';
                        if (addField(field)) {
                            return {
                                fields: _result,
                                index: i
                            };
                        }
                    } else if (_currentPhase === phase.lookingForDelimiter) {
                        let field = _source.substring(_startIndex, i);
                        if (addField(field)) {
                            return {
                                fields: _result,
                                index: i
                            };
                        }
                    }
                    break;

                case _doubleQuotas:
                    if (_currentPhase === phase.none) {
                        setStartIndexIfNone(i);
                        _currentPhase = phase.lookingForDoubleQuotas;
                    } else if (_currentPhase === phase.lookingForDoubleQuotas) {
                        let isEscapedDoubleQuotas = i - 1 > 0 && _source[i - 1] === '\\';
                        if (!isEscapedDoubleQuotas) {
                            _currentPhase = phase.lookingForDelimiter;
                        }
                    }
                    break;

                case ' ':
                    if (_currentPhase === phase.none) {
                        setStartIndexIfNone(i);
                    }
                    break;

                default:
                    if (_currentPhase === phase.none) {
                        setStartIndexIfNone(i);
                        _currentPhase = phase.lookingForDelimiter;
                    }
                    break;
            }
        }

        if (_startIndex) {
            let field = _source.substring(_startIndex);
            addField(field);
        }

        return {
            fields: _result,
            index: _source.length - 1
        };
    }

    return {
        parse
    };
};

var csvContactsParserFactory = function (runtime, extensionId) {

    let _extensionId = extensionId;
    let _runtime = runtime;

    async function sendMessage(message) {
        const result = await _runtime.sendExtensionMessage(_extensionId, message);
        return result;
    }

    async function reportUnhandledError(parameters, metadata) {
        let command = backendCommandsFactory.logging.createLogError(logEntryIds.unhandledError, parameters, metadata);
        let result = await sendMessage(command);
        return result;
    }

    function areEqualIgnoreCase(first, second) {
        let result = first.toLowerCase() === second.toLowerCase();
        return result;
    }

    function createEmptyHeaderMapping() {
        let result = {
            LinkedInProfileIndex: -1,
            FirstNameIndex: -1,
            LastNameIndex: -1,
            CompanyIndex: -1,
            TitleIndex: -1,
            CountryIndex: -1,
            CustomField1: -1,
            CustomField2: -1,
            CustomField3: -1
        };
        return result;
    }

    function getHeaderMapping(fields) {
        let result = createEmptyHeaderMapping();
        for (let i = 0; i <= fields.length - 1; i++) {
            let currentField = fields[i];
            if (areEqualIgnoreCase(currentField, "LinkedIn Profile")) {
                result.LinkedInProfileIndex = i;
            }

            if (areEqualIgnoreCase(currentField, "First Name")) {
                result.FirstNameIndex = i;
            }

            if (areEqualIgnoreCase(currentField, "Last Name")) {
                result.LastNameIndex = i;
            }

            if (areEqualIgnoreCase(currentField, "Company Name")) {
                result.CompanyIndex = i;
            }

            if (areEqualIgnoreCase(currentField, "Position Title")) {
                result.TitleIndex = i;
            }

            if (areEqualIgnoreCase(currentField, "Country")) {
                result.CountryIndex = i;
            }

            if (areEqualIgnoreCase(currentField, "Custom Field 1")) {
                result.CustomField1 = i;
            }

            if (areEqualIgnoreCase(currentField, "Custom Field 2")) {
                result.CustomField2 = i;
            }

            if (areEqualIgnoreCase(currentField, "Custom Field 3")) {
                result.CustomField3 = i;
            }
        }

        return result;
    }

    function extractLinkedInIds(source, metadata) {
        if (!source) {
            source = '';
        }

        const linkedInProfiles = [...source.matchAll(/(?:\s|)?linkedin\.com\/in\/(?<identifier>.[^/\s,;:*."'#@$?+<>\][]*)/gmi)];
        const salesNavigatorProfiles = [...source.matchAll(/(?:\s|)?linkedin\.com\/sales\/lead\/(?<identifier>.[^/\s,;:*."'#@$?+<>\][]*)/gmi)];
        let profiles = linkedInProfiles.concat(salesNavigatorProfiles);
        let rawResult = [];
        for (const match of profiles) {
            try {
                let identifier = decodeURI(match.groups.identifier);
                rawResult.push(identifier);
            } catch (error) {
                let parameters = errorParametersFactory.create(error);
                parameters.identifier = match.groups.identifier;
                parameters.csvImport = true;
                // noinspection JSIgnoredPromiseFromCall
                reportUnhandledError(parameters, metadata);
            }
        }
        let result = [...new Set(rawResult)];
        return result;
    }

    function createContact(publicIdentifier, firstName, lastName, fullName, companyName, title, country, customField1, customField2, customField3) {
        let result = {
            miniProfile: {
                publicIdentifier,
                fullName,
                firstName,
                lastName
            },
            country,
            location: country,
            lastJob: null,
            // lastJob: {
            //     companyName: "Svitlo Systems",
            //     title: "Support Engineer"
            // }
            customField1,
            customField2,
            customField3
        };

        if (companyName || title) {
            result.lastJob = {
                companyName,
                title
            };
        }

        return result;
    }

    function extractContact(headerMapping, fields, metadata) {
        let result = null;
        let publicIdentifier = null;
        if (fields.length > headerMapping.LinkedInProfileIndex) {
            let linkedInProfile = fields[headerMapping.LinkedInProfileIndex];
            let ids = extractLinkedInIds(linkedInProfile, metadata);
            if (ids.length > 0) {
                publicIdentifier = ids[0];
            }
        }

        if (publicIdentifier) {
            let firstName = null;
            let lastName = null;
            let company = null;
            let title = null;
            let fullName = null;
            let country = null;
            let customField1 = null;
            let customField2 = null;
            let customField3 = null;
            if (headerMapping.FirstNameIndex && fields.length > headerMapping.FirstNameIndex) {
                firstName = fields[headerMapping.FirstNameIndex];
            }

            if (headerMapping.LastNameIndex && fields.length > headerMapping.LastNameIndex) {
                lastName = fields[headerMapping.LastNameIndex];
            }

            if (headerMapping.CompanyIndex && fields.length > headerMapping.CompanyIndex) {
                company = fields[headerMapping.CompanyIndex];
            }

            if (headerMapping.TitleIndex && fields.length > headerMapping.TitleIndex) {
                title = fields[headerMapping.TitleIndex];
            }

            if (headerMapping.CountryIndex && fields.length > headerMapping.CountryIndex) {
                country = fields[headerMapping.CountryIndex];
            }

            if (headerMapping.CustomField1 && fields.length > headerMapping.CustomField1) {
                customField1 = fields[headerMapping.CustomField1];
            }

            if (headerMapping.CustomField2 && fields.length > headerMapping.CustomField2) {
                customField2 = fields[headerMapping.CustomField2];
            }

            if (headerMapping.CustomField3 && fields.length > headerMapping.CustomField3) {
                customField3 = fields[headerMapping.CustomField3];
            }

            if (firstName || lastName) {
                if (firstName) {
                    fullName = firstName;
                }

                if (lastName) {
                    if (fullName) {
                        fullName += " ";
                    }

                    fullName += lastName;
                }

                fullName = fullName.trim();
            } else {
                fullName = publicIdentifier;
            }
            result = createContact(publicIdentifier, firstName, lastName, fullName, company, title, country, customField1, customField2, customField3);

        }

        return result;
    }

    function parseLinkedInContacts(source, metadata) {
        let ids = extractLinkedInIds(source, metadata);
        let result = [];
        for (const id of ids) {
            let contact = createContact(id, null, null, id, null, null, null, null, null, null);
            result.push(contact);
        }
        return result;
    }

    // explicitlyDefinedSeparator is not yet support, only parsed
    function getHeaderDefinition(headerLine, explicitlyDefinedSeparator) {
        let delimiters = [";", ",", "\t"];
        const fieldsCount = getFieldsCount();
        for (const delimiter of delimiters) {
            let parser = csvLineParserFactory(headerLine, delimiter);
            let response = parser.parse(0, fieldsCount);
            let mapping = getHeaderMapping(response.fields);
            if (isValidHeaderMapping(mapping)) {
                let result = {
                    delimiter,
                    mapping
                };
                return result;
            }
        }

        throw new InvalidOperationError("This file is not Snaily csv file");
    }

    function getFieldsCount() {
        const result = Object.keys(createEmptyHeaderMapping()).length;
        return result;
    }

    function parseFullLinkedInContacts(source, metadata) {
        let allLines = source.replaceAll("\r\n", "\n")
            .split("\n");

        let result = [];
        if (allLines.length > 0) {
            let headerLine = allLines[0];
            let skipLines = 1;
            let separatorPrefix = "sep=";
            if (headerLine.toLowerCase().startsWith(separatorPrefix)) {
                headerLine.substring(separatorPrefix.length);
                headerLine = allLines[1];
                skipLines = 2;
            }

            let headerDefinition = getHeaderDefinition(headerLine);
            let recordsText = allLines.slice(skipLines).join('\n');
            let currentIndex = 0;
            const fieldsCount = getFieldsCount();
            do {
                let parser = csvLineParserFactory(recordsText, headerDefinition.delimiter);
                let response = parser.parse(currentIndex, fieldsCount);
                let contact = extractContact(headerDefinition.mapping, response.fields, metadata);
                if (contact) {
                    result.push(contact);
                }
                currentIndex = response.index + 1;
            } while (currentIndex < recordsText.length - 1);
        } else {
            throw new InvalidOperationError("This file is not Snaily csv file");
        }

        return result;
    }

    function isValidHeaderMapping(mapping) {
        let result = !(mapping.LinkedInProfileIndex < 0 ||
            mapping.FirstNameIndex < 0 ||
            mapping.LastNameIndex < 0 ||
            mapping.CompanyIndex < 0 ||
            mapping.TitleIndex < 0 ||
            mapping.CountryIndex < 0 ||
            mapping.CustomField1 < 0 ||
            mapping.CustomField2 < 0 ||
            mapping.CustomField3 < 0);
        return result;
    }

    let result = {
        parseFullLinkedInContacts,
        parseLinkedInContacts
    };

    return result;
};

var connectorFactory3865 = function (extensionId) {

    const _extensionId = extensionId;
    const _runtime = runtimeAdapterFactory();
    let _suppressSnailyEvents = false;
    const _eventHandlers = {};

    let _currentLinkedInProfileDetectedResolver;
    let _popup;

    async function sendMessage(message) {
        const result = await _runtime.sendExtensionMessage(_extensionId, message);
        return result;
    }

    function resetCapturingLinkedInProfile() {
        if (_popup) {
            _popup.close();
        }

        _currentLinkedInProfileDetectedResolver = null;
        _popup = null;
    }

    function onLinkedInProfileDetectedHandler() {
        try {
            if (_currentLinkedInProfileDetectedResolver) {
                _currentLinkedInProfileDetectedResolver();
            }
        } finally {
            resetCapturingLinkedInProfile();
        }
    }

    function addEventHandler(eventName, handler) {
        if (!_eventHandlers[eventName]) {
            _eventHandlers[eventName] = [];
        }

        _eventHandlers[eventName].push(handler);
    }

    function removeEventHandler(eventName) {
        _eventHandlers[eventName] = [];
    }

    async function getExtensionVersion(metadata) {
        let command = backendCommandsFactory.system.createGetExtensionSettings(metadata);
        let response = await sendMessage(command);
        let result = response.version;
        return result;
    }

    async function getSignedInLinkedInProfile(metadata) {
        let command = backendCommandsFactory.linkedInService.createGetCurrentProfile(metadata);
        let result = await sendMessage(command);
        return result;
    }

    async function getAssociatedLinkedInProfile(metadata) {
        let command = backendCommandsFactory.localStorage.createGetLinkedInProfile(metadata);
        let result = await sendMessage(command);
        return result;
    }

    async function exchangeAuthorizationCode(code, metadata) {
        let command = backendCommandsFactory.apiProxy.createExchangeAuthorizationCode(code, metadata);
        await sendMessage(command);
    }

    async function addLinkedInProfile(profile, metadata) {
        let command = backendCommandsFactory.apiProxy.createAddLinkedInProfile(profile, metadata);
        let result = await sendMessage(command);
        return result;
    }

    async function getLinkedInProfiles(metadata) {
        let command = backendCommandsFactory.apiProxy.createGetLinkedInProfiles(metadata);
        const result = await sendMessage(command);
        return result;
    }

    async function resetVoyageSpyCache(metadata) {
        let command = backendCommandsFactory.linkedInVoyagerSpy.createResetCache(metadata);
        let result = await sendMessage(command);
        return result;
    }

    async function getLinkedInHomeUrl(metadata) {
        let command = backendCommandsFactory.settings.createGetApplicationsSettings(metadata);
        let settings = await sendMessage(command);
        let result = settings.linkedIn.homeUrl;
        return result;
    }

    async function captureLinkedInProfile(duration, metadata) {
        await resetVoyageSpyCache(metadata);

        let homeUrl = await getLinkedInHomeUrl(metadata);
        _popup = window.open(homeUrl, "_target", 'height=700,width=700,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');
        let timerId = setInterval(function () {
            if (!_popup || _popup.closed) {
                clearInterval(timerId);
                onLinkedInProfileDetectedHandler();
            }
        }, 200);

        const promise = new SnailyPromise(function (resolve) {
            _currentLinkedInProfileDetectedResolver = resolve;
            //disable it, it harm more
            //setTimeout(reject, duration * 1000, {message: 'Timeout'});
        });

        await promise;
    }

    async function broadcastSnailyEvent(snailyEvent) {
        if (_eventHandlers[snailyEvent.event]) {
            for (const handler of _eventHandlers[snailyEvent.event]) {
                if (await handler(snailyEvent.event.args)) {
                    return;
                }
            }
        }
    }

    document.addEventListener("SnailyEvent", async function (e) {
        if (!_suppressSnailyEvents) {
            await broadcastSnailyEvent(e.detail);
        }
    });

    addEventHandler(eventNames.linkedInProfileDetected, onLinkedInProfileDetectedHandler);

    async function isInWorkingHours(metadata) {
        let command = backendCommandsFactory.campaignsRunner.createIsInWorkingHours(metadata);
        let result = await sendMessage(command);
        return result;
    }

    const factory = {

        auth: {

            async signIn (state, referrer, metadata) {
                metadata ??= metadataFactory.create();
                if (!referrer || referrer === '') {
                    referrer = '<none>';
                }

                let message = backendCommandsFactory.auth.createGetSignInUri(state, referrer, metadata);
                const uri = await sendMessage(message);
                window.open(uri, "_self");
            },

            async signOut (metadata) {
                metadata ??= metadataFactory.create();

                let message = backendCommandsFactory.auth.createSignOut(metadata);
                await sendMessage(message);
            },

            async getSnailyProfile (metadata) {
                metadata ??= metadataFactory.create();

                let command = backendCommandsFactory.localStorage.createGetSnailyProfile(metadata);
                let result = await sendMessage(command);
                return result;
            },

            async getAssociatedLinkedInProfile (metadata) {
                metadata ??= metadataFactory.create();

                let result = await getAssociatedLinkedInProfile(metadata);
                return result;
            },

            async isSignedInUnderAssociatedLinkedInProfile (metadata) {
                metadata ??= metadataFactory.create();

                let associatedLinkedInProfile = await getAssociatedLinkedInProfile(metadata);
                if (!associatedLinkedInProfile) {
                    throw new InvalidOperationError("Function is called in irrelevant context. Snaily profile registration is not ended, there is no associated linkedInProfile.", metadata);
                }

                const signedInLinkedInProfile = await getSignedInLinkedInProfile(metadata);
                let result = signedInLinkedInProfile && signedInLinkedInProfile.entityId === associatedLinkedInProfile.entityId;
                return result;
            },

            async exchangeAuthorizationCode (code, metadata) {
                metadata ??= metadataFactory.create();

                await exchangeAuthorizationCode(code, metadata);
            },

            async getAccessToken (metadata) {
                metadata ??= metadataFactory.create();

                try {
                    const command = backendCommandsFactory.apiProxy.createGetAccessToken(metadata);
                    const result = await sendMessage(command);
                    return result;
                } catch (exp) {
                    if (exp instanceof MissingReceiverExtensionRuntimeError) {
                        throw new ExtensionNotInstalledError("Extension is not installed", metadata);
                    }

                    throw exp;
                }
            },

            async refreshAccessToken (metadata) {
                metadata ??= metadataFactory.create();

                const command = backendCommandsFactory.apiProxy.createRefreshAuthTokens(metadata);
                await sendMessage(command);
            },

            async switchToWorkspace (linkedInProfileId, metadata) {
                if (!linkedInProfileId) {
                    throw new Error('Argument - linkedInProfileId is not set.');
                }

                metadata ??= metadataFactory.create();

                let command = backendCommandsFactory.apiProxy.createSwitchToWorkspace(linkedInProfileId, metadata);
                await sendMessage(command);
            },

            async signInUnderTeamMember (personaId, metadata) {
                metadata ??= metadataFactory.create();

                let command = backendCommandsFactory.apiProxy.createSignInUnderTeamMember(personaId, metadata);
                await sendMessage(command);
            },

            async signOutUnderTeamMember (personaId, metadata) {
                metadata ??= metadataFactory.create();

                let command = backendCommandsFactory.apiProxy.createSignOutUnderTeamMember(metadata);
                await sendMessage(command);
            }

        },

        automation: {

            async isInWorkingHours (metadata) {
                metadata ??= metadataFactory.create();

                let result = await isInWorkingHours(metadata);
                return result;
            }

        },

        linkedIn: {

            async getCurrentProfile(metadata) {
                metadata ??= metadataFactory.create();

                let result = await getSignedInLinkedInProfile(metadata);
                return result;
            },

            async captureCurrentProfile(duration, metadata) {
                metadata ??= metadataFactory.create();

                let result = await getSignedInLinkedInProfile(metadata);
                if (result) {
                    console.log(result)
                    return result;
                }

                duration ||= 5;


                try {
                    await captureLinkedInProfile(duration, metadata);
                } catch (exp) {
                    resetCapturingLinkedInProfile();
                    console.log(exp);
                    //timeout
                }

                result = await getSignedInLinkedInProfile(metadata);
    
                return result;
            },

        },

        api: {

            async getLinkedInProfiles (metadata) {
                metadata ??= metadataFactory.create();

                const result = await getLinkedInProfiles(metadata);
                return result;
            },

            async addLinkedInProfile (profile, metadata) {
                if (!profile) {
                    throw new Error('Argument - profile is not set.');
                }

                metadata ??= metadataFactory.create();

                const result = await addLinkedInProfile(profile, metadata);
                return result;
            },

            async isCompatibleWithCurrentExtension (metadata) {
                metadata ??= metadataFactory.create();

                let command = backendCommandsFactory.apiProxy.createIsCompatibleWithCurrentExtension(metadata);
                let result = await sendMessage(command);
                return result;
            }
        },

        extension: {

            async isInstalled (metadata) {
                metadata ??= metadataFactory.create();

                let command = backendCommandsFactory.localStorage.createGetUserLogLevel(metadata);
                try {
                    await sendMessage(command);
                } catch (e) {
                    return false;
                }

                return true;
            },

            async getExtensionVersion (metadata) {
                metadata ??= metadataFactory.create();
                let result = await getExtensionVersion(metadata);
                return result;
            }

        },

        utils: {

            createMetadata () {
                const result = metadataFactory.create();
                return result;
            }

        },

        profilesExport: {

            async extractLinkedInContacts (source, metadata) {
                let result = csvContactsParserFactory(_runtime, _extensionId).parseLinkedInContacts(source, metadata);
                return result;
            },

            async extractFullLinkedInContacts (source, metadata) {
                let result = csvContactsParserFactory(_runtime, _extensionId).parseFullLinkedInContacts(source, metadata);
                return result;
            },

            async start (source, metadata) {
                if (!source) {
                    throw new InvalidOperationError("contacts are not set", metadata);
                }

                metadata ??= metadataFactory.create();

                let extensionVersion = await getExtensionVersion(metadata);
                if (extensionVersion >= "3.8.0.2") {
                    let command = backendCommandsFactory.automation.createStartCsvContactsExport(contactsExportType.csvContactsList, source, metadata);
                    await sendMessage(command);
                } else {
                    let command = backendCommandsFactory.automation.createStartCsvExport(contactsExportType.contactsPublicIdentifierList, source, metadata);
                    await sendMessage(command);
                }
            },

            async stop (metadata) {
                metadata ??= metadataFactory.create();

                let message = backendCommandsFactory.automation.createStopExport(metadata);
                let result = await sendMessage(message);
                return result;
            },

            async clear (metadata) {
                metadata ??= metadataFactory.create();

                let message = backendCommandsFactory.automation.createClearExport(metadata);
                let result = await sendMessage(message);
                return result;
            },

            async getState (metadata) {
                metadata ??= metadataFactory.create();

                let message = backendCommandsFactory.automation.createGetExportState(metadata);
                let result = await sendMessage(message);
                return result;
            },

            addExportStartingHandler (handler) {
                addEventHandler(eventNames.exportStarting, handler);
            },

            addExportStartedHandler (handler) {
                addEventHandler(eventNames.exportStarted, handler);
            },

            addExportClearedHandler (handler) {
                addEventHandler(eventNames.exportCleared, handler);
            },

            addExportChangedHandler (handler) {
                addEventHandler(eventNames.exportChanged, handler);
            },

            addExportFailedHandler (handler) {
                addEventHandler(eventNames.exportFailed, handler);
            },

            addExportCompletingHandler (handler) {
                addEventHandler(eventNames.exportCompleting, handler);
            },

            addExportCompletedHandler (handler) {
                addEventHandler(eventNames.exportCompleted, handler);
            },

            removedAllHandlers () {
                removeEventHandler(eventNames.exportStarting);
                removeEventHandler(eventNames.exportStarted);
                removeEventHandler(eventNames.exportCleared);
                removeEventHandler(eventNames.exportChanged);
                removeEventHandler(eventNames.exportFailed);
                removeEventHandler(eventNames.exportCompleting);
                removeEventHandler(eventNames.exportCompleted);
            }
        },

        eventHandlers: {

            suppressEvents () {
                _suppressSnailyEvents = true;
            },

            enableEvents () {
                _suppressSnailyEvents = false;
            },

            addLinkedInSignedOutEventHandler (handler) {
                addEventHandler(eventNames.linkedInSignedOut, handler);
            },

            addLinkedInProfileDetectedHandler (handler) {
                addEventHandler(eventNames.linkedInProfileDetected, handler);
            },

            addSnailySignedInEventHandler (handler) {
                addEventHandler(eventNames.snailySignedIn, handler);
            },

            addSnailySignedOutEventHandler (handler) {
                addEventHandler(eventNames.snailySignedOut, handler);
            },

            addSnailyProfileChangedEventHandler (handler) {
                addEventHandler(eventNames.snailyProfileChanged, handler);
            },

            addAutomationEndedEventHandler (handler) {
                addEventHandler(eventNames.automationEnded, handler);
            },

            removeAutomationEndedEventHandlers () {
                removeEventHandler(eventNames.automationEnded);
            },

            addWorkingHoursChangedHandler (handler) {
                addEventHandler(eventNames.workingHoursChanged, handler);
            },

            removeWorkingHoursChangedHandler (handler) {
                addEventHandler(eventNames.workingHoursChanged, handler);
            },

        }

    };

    return factory;

};

 

var connectorFactory = function (extensionId) {
    let _connector = null;
    let _correlationFactory = null;

    function getConnector(metadata) {
        if(!_connector) 
            throw new ExtensionNotInstalledError("Extension is not installed", metadata);
        

        return _connector;
    }

    function setConnector(connector) {
        _connector = connector;
    }

    const factory = {

        auth: {

            async signIn (state, referrer, metadata) {
                metadata ??= _correlationFactory();
                await getConnector(metadata).auth.signIn(state, referrer, metadata);
            },

            async signOut (metadata) {
                metadata ??= _correlationFactory();

                await getConnector(metadata).auth.signOut(metadata);
            },

            async getSnailyProfile (metadata) {
                metadata ??= _correlationFactory();

                let result = await getConnector(metadata).auth.getSnailyProfile(metadata);
                return result;
            },

            async getAssociatedLinkedInProfile (metadata) {
                metadata ??= _correlationFactory();

                let result = await getConnector(metadata).auth.getAssociatedLinkedInProfile(metadata);
                return result;
            },

            async isSignedInUnderAssociatedLinkedInProfile (metadata) {
                metadata ??= _correlationFactory();

                let result = await getConnector(metadata).auth.isSignedInUnderAssociatedLinkedInProfile(metadata);
                return result;
            },

            async exchangeAuthorizationCode (code, metadata) {
                metadata ??= _correlationFactory();

                await getConnector(metadata).auth.exchangeAuthorizationCode(code, metadata);
            },

            async getAccessToken (metadata) {
                metadata ??= _correlationFactory();

                try {
                    const result = await getConnector(metadata).auth.getAccessToken(metadata);
                    return result;
                } catch(exp) {
                    if(exp.name === "ExtensionNotInstalledError") {
                        setConnector(null);
                    }

                    throw exp;
                }

            },

            async refreshAccessToken (metadata) {
                metadata ??= _correlationFactory();

                await getConnector(metadata).auth.refreshAccessToken(metadata);
            },

            async switchToWorkspace (linkedInProfileId, metadata) {
                metadata ??= _correlationFactory();

                await getConnector(metadata).auth.switchToWorkspace(linkedInProfileId, metadata);
            },

            async signInUnderTeamMember (personaId, metadata) {
                metadata ??= _correlationFactory();

                await getConnector(metadata).auth.signInUnderTeamMember(personaId, metadata);
            },

            async signOutUnderTeamMember (metadata) {
                metadata ??= _correlationFactory();

                await getConnector(metadata).auth.signOutUnderTeamMember(metadata);
            }

        },

        automation: {

            async isInWorkingHours (metadata) {
                metadata ??= _correlationFactory();

                let result = await getConnector(metadata).automation.isInWorkingHours(metadata);
                return result;
            }

        },

        linkedIn: {

            async getCurrentProfile(metadata) {
                metadata ??= _correlationFactory();

                let result = await getConnector(metadata).linkedIn.getCurrentProfile(metadata);
                return result;
            },

            async captureCurrentProfile(duration, metadata) {
                metadata ??= _correlationFactory();

                let result = await getConnector(metadata).linkedIn.captureCurrentProfile(duration, metadata);
                return result;
            },

        },

        api: {

            async getLinkedInProfiles (metadata) {
                metadata ??= _correlationFactory();

                let result = await getConnector(metadata).api.getLinkedInProfiles(metadata);
                return result;
            },

            async addLinkedInProfile (profile, metadata) {
                metadata ??= _correlationFactory();

                let result = await getConnector(metadata).api.addLinkedInProfile(profile, metadata);
                return result;
            },

            async isCompatibleWithCurrentExtension (metadata) {
                metadata ??= _correlationFactory();

                let result = await getConnector(metadata).api.isCompatibleWithCurrentExtension(metadata);
                return result;
            }
        },

        extension: {

            isInstalled (metadata) {
                let connector = null;
                try {
                    connector = getConnector(metadata);
                } catch(exp) {
                    if(!(exp.name === "ExtensionNotInstalledError")) {
                        throw exp;
                    }
                }

                let result = !!connector;
                return result;
            }

        },

        utils: {

            createMetadata () {
                const result = _correlationFactory();
                return result;
            }

        },

        profilesExport: {

            extractLinkedInContacts (source, metadata) {
                metadata ??= _correlationFactory();

                let result = getConnector(metadata).profilesExport.extractLinkedInContacts(source, metadata);
                return result;
            },

            extractFullLinkedInContacts (source, metadata) {
                metadata ??= _correlationFactory();

                let result = getConnector(metadata).profilesExport.extractFullLinkedInContacts(source, metadata);
                return result;
            },

            async start (publicIdentifiers, metadata) {
                metadata ??= _correlationFactory();

                let result = getConnector(metadata).profilesExport.start(publicIdentifiers, metadata);
                return result;
            },

            async stop (metadata) {
                metadata ??= _correlationFactory();

                let result = getConnector(metadata).profilesExport.stop(metadata);
                return result;
            },

            async clear (metadata) {
                metadata ??= _correlationFactory();

                let result = getConnector(metadata).profilesExport.clear(metadata);
                return result;
            },

            async getState (metadata) {
                metadata ??= _correlationFactory();

                let result = getConnector(metadata).profilesExport.getState(metadata);
                return result;
            },

            addExportStartingHandler (handler, metadata) {
                getConnector(metadata).profilesExport.addExportStartingHandler(handler);
            },

            addExportStartedHandler (handler, metadata) {
                getConnector(metadata).profilesExport.addExportStartedHandler(handler);
            },

            addExportClearedHandler (handler, metadata) {
                getConnector(metadata).profilesExport.addExportClearedHandler(handler);
            },

            addExportChangedHandler (handler, metadata) {
                getConnector(metadata).profilesExport.addExportChangedHandler(handler);
            },

            addExportFailedHandler (handler, metadata) {
                getConnector(metadata).profilesExport.addExportFailedHandler(handler);
            },

            addExportCompletingHandler (handler, metadata) {
                getConnector(metadata).profilesExport.addExportCompletingHandler(handler);
            },

            addExportCompletedHandler (handler, metadata) {
                getConnector(metadata).profilesExport.addExportCompletedHandler(handler);
            },

            removedAllHandlers (metadata) {
                getConnector(metadata).profilesExport.removedAllHandlers();
            }
        },

        eventHandlers: {

            suppressEvents (metadata) {
                getConnector(metadata).eventHandlers.suppressEvents();
            },

            enableEvents (metadata) {
                getConnector(metadata).eventHandlers.enableEvents();
            },

            addLinkedInSignedOutEventHandler (handler, metadata) {
                getConnector(metadata).eventHandlers.addLinkedInSignedOutEventHandler(handler);
            },

            addLinkedInProfileDetectedHandler (handler, metadata) {
                getConnector(metadata).eventHandlers.addLinkedInProfileDetectedHandler(handler);
            },

            addSnailySignedInEventHandler (handler, metadata) {
                getConnector(metadata).eventHandlers.addSnailySignedInEventHandler(handler);
            },

            addSnailySignedOutEventHandler (handler, metadata) {
                getConnector(metadata).eventHandlers.addSnailySignedOutEventHandler(handler);
            },

            addSnailyProfileChangedEventHandler (handler, metadata) {
                getConnector(metadata).eventHandlers.addSnailyProfileChangedEventHandler(handler);
            },

            addAutomationEndedEventHandler (handler, metadata) {
                getConnector(metadata).eventHandlers.addAutomationEndedEventHandler(handler);
            },

            removeAutomationEndedEventHandlers (metadata) {
                getConnector(metadata).eventHandlers.removeAutomationEndedEventHandlers();
            },

            addWorkingHoursChangedHandler (handler, metadata) {
                getConnector(metadata).eventHandlers.addWorkingHoursChangedHandler(handler);
            },

            removeWorkingHoursChangedHandler (handler, metadata) {
                getConnector(metadata).eventHandlers.removeWorkingHoursChangedHandler(handler);
            },

        },

        async init (metadata) {
            if(!metadata) {
                metadata = metadataFactory.create();
            }

            let connector3865 = connectorFactory3865(extensionId);
            let extensionVersion = null;

            try {
                extensionVersion = await connector3865.extension.getExtensionVersion(metadata);
            } catch(e3865) {
                // try {
                //     extensionVersion = await connector3864.extension.getExtensionVersion(metadata);
                // } catch(e3864) {
                //     extensionVersion = null;
                // }
                extensionVersion = null;
            }

            if(extensionVersion) {
                if(extensionVersion >= "3.8.6.5") {
                    setConnector(connector3865);
                } else {
                    setConnector(connector3865);
                }

                _correlationFactory = metadataFactory.create;
            }
        }

    };

    return factory;

};

export { connectorFactory };
